/**
 * Internal logger for the widget SDK.
 * Prevents console pollution on customer websites.
 */
const isDebug = () => {
    if (typeof window === 'undefined') return false;
    if (window.__IGREET_DEBUG__) return true;
    try {
        if (window.localStorage && window.localStorage.getItem('IGREET_DEBUG') === 'true') {
            return true;
        }
    } catch (e) {
        // Ignore localStorage access errors (e.g. cross-origin restrictions)
    }
    return false;
};

export const logger = {
    info: (...args) => { if (isDebug()) console.log(...args); },
    warn: (...args) => { if (isDebug()) console.warn(...args); },
    error: (...args) => { if (isDebug()) console.error(...args); },
    debug: (...args) => { if (isDebug()) console.debug(...args); }
};
